module.exports = __webpack_public_path__ + "img/new-york.7c31ead3.jpg";